export type MarketplacePlatform = 'mercadolivre' | 'shopee';

export interface MarketplaceConnectionLike {
  id: string;
  connectionName?: string | null;
  displayName?: string | null;
  externalId?: string | null;
  nickname?: string | null;
  userId?: number;
  shopId?: number;
  shopName?: string | null;
}

export function getMarketplacePlatformLabel(platform: MarketplacePlatform) {
  return platform === 'mercadolivre' ? 'Mercado Livre' : 'Shopee';
}

export function getMarketplaceConnectionDisplayName(
  platform: MarketplacePlatform,
  connection: MarketplaceConnectionLike
) {
  if (connection.connectionName?.trim()) return connection.connectionName.trim();
  if (connection.displayName?.trim()) return connection.displayName.trim();

  if (platform === 'mercadolivre') {
    if (connection.nickname?.trim()) return connection.nickname.trim();
    if (connection.userId) return `Conta ${connection.userId}`;
    return 'Conta Mercado Livre';
  }

  if (connection.shopName?.trim()) return connection.shopName.trim();
  if (connection.shopId) return `Loja ${connection.shopId}`;
  return 'Conta Shopee';
}

export function getMarketplaceConnectionExternalId(
  platform: MarketplacePlatform,
  connection: MarketplaceConnectionLike
) {
  if (connection.externalId?.trim()) return connection.externalId.trim();
  return platform === 'mercadolivre'
    ? connection.userId?.toString() || ''
    : connection.shopId?.toString() || '';
}
